<script setup>
import { ref, computed, defineAsyncComponent, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
/***/
import { useCoachingOfferStore } from '@stores/coachingOffer';
import { useApplicationStore } from '@stores/application';
import { useHistoryStore } from '@stores/history';
/***/
import { useAuthUser } from '@compositions/Auth';

// Composants
const Layout = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Layouts/Authenticated'));
const EditForm = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Partial/Admin/CoachingOffers/EditForm'));

const router = useRouter();
const route = useRoute();
const { t } = useI18n();

// Store
const applicationStore = useApplicationStore();
const coachingOfferStore = useCoachingOfferStore();
const historyStore = useHistoryStore();

const currentApplication = computed(() => applicationStore.getCurrent);

const { authUser, authUserHasPermission } = useAuthUser({});
const allowed = ref(false);
const pageTitle = ref(null);
const pageDescription = ref(null);

onMounted(() => {
    if(! authUserHasPermission('create coaching offer')) {
        router.push({
            name: 'error',
            params: {
                statusCode: 404
            }
        });
    } else {
        const titleKey = 'page.admin.coachingOffers.create.title';
        const descriptionKey = 'page.admin.coachingOffers.create.description';
        document.title = t(titleKey) + ' - ' + currentApplication.value.name;
        pageTitle.value = t(titleKey);
        pageDescription.value = t(descriptionKey);

        allowed.value = true;
    }
});

// Méthode exécutée après la création d'une offre de coaching
const onCreateOffer = ((offer) => {
    historyStore.setMustPreserveScrollPosition(true);
    coachingOfferStore.updateOffer(offer);
    router.push({
        name: 'admin.coaching-offers.edit',
        params: {
            offerId: offer.id
        },
        query: {
            'from-create': 1
        }
    });
});
</script>

<template>
    <layout v-if="allowed" wrapperContentClasses="wrapper_edit-add">
        <div class="content_header">
            <div class="content-header_title">
                <h1 class="first-title">{{ pageTitle }}</h1>
                <p>{{ pageDescription }}</p>
            </div>
        </div>
        <div class="wrapper_content ">
            <edit-form
                v-on:offer-save="onCreateOffer($event)"
            ></edit-form>
        </div>
    </layout>
</template>
